module.exports = __webpack_public_path__ + "img/charm_6.083fc450.png";